import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'

const RouteWithSubRoutes = ({ routes, render, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return render({ ...props, ...rest, routes })
      }}
    />
  )
}

RouteWithSubRoutes.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      name: PropTypes.string,
      authenticated: PropTypes.bool,
      render: PropTypes.func.isRequired,
      exact: PropTypes.bool
    })
  ),
  render: PropTypes.func.isRequired
}

export { RouteWithSubRoutes }
